var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tile" },
    [
      _c("div", { staticClass: "tile is-parent" }, [
        _c("article", { staticClass: "tile is-child" }, [
          _c("div", { staticClass: "columns title" }, [
            _c("div", { staticClass: "column" }, [
              _c("div", { staticClass: "subtitle" }, [
                _c("div", { staticClass: "p-1" }, [
                  _c("div", { staticClass: "is-flex columns" }, [
                    _c("div", { staticClass: "column" }, [
                      _c("div", [
                        _c("span", { staticClass: "category-name" }, [
                          _vm._v(_vm._s(_vm.category)),
                        ]),
                        _vm.isPrivate
                          ? _c("span", { staticClass: "icon pl-3" }, [
                              _c("i", {
                                staticClass: "mdi mdi-eye-off mdi-24px",
                              }),
                            ])
                          : _vm._e(),
                        _vm.imagesWithInfo.length > 0
                          ? _c("span", {
                              staticClass:
                                "has-badge-rounded has-badge-info has-badge-large pl-3",
                              attrs: {
                                "data-badge": _vm.imagesWithInfo.length,
                              },
                            })
                          : _vm._e(),
                      ]),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass:
                          "is-flex column is-narrow is-justify-content-flex-end",
                      },
                      [
                        _c("p", { staticClass: "buttons" }, [
                          _vm.imagesWithInfo.length > 0 &&
                          _vm.isCategorySelectAllEnable
                            ? _c(
                                "a",
                                {
                                  staticClass: "button tooltip",
                                  attrs: {
                                    "data-tooltip": "Select all",
                                    disabled: _vm.isLoadingImages,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setSelectedStatusAll(true)
                                    },
                                  },
                                },
                                [_vm._m(0)]
                              )
                            : _vm._e(),
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.hasSelected &&
                                    _vm.isCategorySelectAllEnable,
                                  expression:
                                    "hasSelected && isCategorySelectAllEnable",
                                },
                              ],
                              staticClass: "button tooltip",
                              attrs: { "data-tooltip": "Deselect all" },
                              on: {
                                click: function ($event) {
                                  return _vm.setSelectedStatusAll(false)
                                },
                              },
                            },
                            [_vm._m(1)]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _c(
            "div",
            [
              _c(
                "draggable",
                {
                  staticClass: "is-flex columns is-multiline dragable-box",
                  attrs: {
                    list: _vm.imagesWithInfo,
                    group: "imagesWithInfo",
                    handle: ".item-drag-handle",
                  },
                  on: {
                    change: (event) =>
                      _vm.onImageOrderChange(_vm.categoryId, event),
                  },
                },
                _vm._l(_vm.imagesWithInfo, function (image, index) {
                  return _c(
                    "div",
                    {
                      key: image.quoteImageId,
                      staticClass: "is-flex column is-narrow p-2 item-drag",
                    },
                    [
                      image.imageContent
                        ? _c(
                            "div",
                            {
                              class: "card",
                              on: {
                                dblclick: function ($event) {
                                  return _vm.makeImagePrimary(image)
                                },
                              },
                            },
                            [
                              _c("header", { staticClass: "card-header" }, [
                                _c(
                                  "div",
                                  { staticClass: "card-header-title p-2" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "is-flex columns is-gapless is-justify-content-space-between",
                                        staticStyle: { width: "100%" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "is-flex column" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "field" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "control" },
                                                  [
                                                    _vm.isImageSelectable
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "pretty p-icon p-curve p-smooth",
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    image.isSelected,
                                                                  expression:
                                                                    "image.isSelected",
                                                                },
                                                              ],
                                                              attrs: {
                                                                id: `chk-pretty-image1${index}`,
                                                                name: `chk-pretty-image${index}`,
                                                                type: "checkbox",
                                                              },
                                                              domProps: {
                                                                checked:
                                                                  Array.isArray(
                                                                    image.isSelected
                                                                  )
                                                                    ? _vm._i(
                                                                        image.isSelected,
                                                                        null
                                                                      ) > -1
                                                                    : image.isSelected,
                                                              },
                                                              on: {
                                                                change: [
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    var $$a =
                                                                        image.isSelected,
                                                                      $$el =
                                                                        $event.target,
                                                                      $$c =
                                                                        $$el.checked
                                                                          ? true
                                                                          : false
                                                                    if (
                                                                      Array.isArray(
                                                                        $$a
                                                                      )
                                                                    ) {
                                                                      var $$v =
                                                                          null,
                                                                        $$i =
                                                                          _vm._i(
                                                                            $$a,
                                                                            $$v
                                                                          )
                                                                      if (
                                                                        $$el.checked
                                                                      ) {
                                                                        $$i <
                                                                          0 &&
                                                                          _vm.$set(
                                                                            image,
                                                                            "isSelected",
                                                                            $$a.concat(
                                                                              [
                                                                                $$v,
                                                                              ]
                                                                            )
                                                                          )
                                                                      } else {
                                                                        $$i >
                                                                          -1 &&
                                                                          _vm.$set(
                                                                            image,
                                                                            "isSelected",
                                                                            $$a
                                                                              .slice(
                                                                                0,
                                                                                $$i
                                                                              )
                                                                              .concat(
                                                                                $$a.slice(
                                                                                  $$i +
                                                                                    1
                                                                                )
                                                                              )
                                                                          )
                                                                      }
                                                                    } else {
                                                                      _vm.$set(
                                                                        image,
                                                                        "isSelected",
                                                                        $$c
                                                                      )
                                                                    }
                                                                  },
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.selectImage(
                                                                      image.quoteImageId,
                                                                      image.isSelected
                                                                    )
                                                                  },
                                                                ],
                                                              },
                                                            }),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "state p-success",
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "icon mdi mdi-check",
                                                                }),
                                                                _c("label"),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "is-flex column is-narrow",
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "has-text-primary is-outlined",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.editImage(
                                                      image.quoteImageId
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "icon" },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "mdi mdi-lead-pencil mdi-24px",
                                                      attrs: {
                                                        "aria-hidden": "true",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm.isDeleteEnable
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "has-text-danger is-outlined",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showDeleteModal(
                                                          image.quoteImageId
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "icon" },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "mdi mdi-delete mdi-24px",
                                                          attrs: {
                                                            "aria-hidden":
                                                              "true",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "item-drag-handle",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "msr msr-24px",
                                                  },
                                                  [_vm._v("drag_indicator")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "card-image image-container" },
                                [
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.viewImage(index)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "figure",
                                        { staticClass: "image is-128x128" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                position: "relative",
                                              },
                                            },
                                            [
                                              image.isPrimary
                                                ? _c("i", {
                                                    staticClass:
                                                      "mdi mdi-star mdi-24px has-text-gold primary-star",
                                                    staticStyle: {
                                                      position: "absolute",
                                                      "z-index": "1",
                                                    },
                                                  })
                                                : _c("i", {
                                                    staticClass:
                                                      "mdi mdi-star mdi-24px has-text-grey-lighter hover-star",
                                                    staticStyle: {
                                                      position: "absolute",
                                                      "z-index": "1",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.setPrimary(
                                                          image.quoteImageId
                                                        )
                                                      },
                                                    },
                                                  }),
                                              image.imageContent
                                                ? _c("img", {
                                                    key: image.quoteImageId,
                                                    staticClass:
                                                      "image is-128x128",
                                                    staticStyle: {
                                                      "object-fit": "cover",
                                                    },
                                                    attrs: {
                                                      src: image.imageContent,
                                                      id: image.quoteImageId,
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "confirm-modal",
        {
          attrs: {
            active: _vm.isConfirmModalActive,
            "ok-text": "Yes",
            "cancel-text": "No",
          },
          on: {
            "update:active": function ($event) {
              _vm.isConfirmModalActive = $event
            },
            ok: function ($event) {
              return _vm.deleteImage(true)
            },
            cancel: function ($event) {
              return _vm.deleteImage(false)
            },
          },
        },
        [
          _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
            _vm._v("Delete image"),
          ]),
          _c("p", { attrs: { slot: "text-content" }, slot: "text-content" }, [
            _vm._v(" Image will be deleted. Continue? "),
          ]),
        ]
      ),
      _c(
        "confirm-modal",
        {
          attrs: {
            active: _vm.isPrimaryConfirmModalActive,
            "ok-text": "Yes",
            "cancel-text": "No",
          },
          on: {
            "update:active": function ($event) {
              _vm.isPrimaryConfirmModalActive = $event
            },
            ok: function ($event) {
              return _vm.confirmSetPrimary(true)
            },
            cancel: function ($event) {
              return _vm.confirmSetPrimary(false)
            },
          },
        },
        [
          _c(
            "p",
            {
              staticClass: "has-text-weight-semibold",
              attrs: { slot: "text-title" },
              slot: "text-title",
            },
            [_vm._v("Set Primary Image")]
          ),
          _c("div", { attrs: { slot: "text-content" }, slot: "text-content" }, [
            _c("p", [
              _vm._v(
                " Are you sure you want to set this image as the primary image? "
              ),
            ]),
            _c("p", { staticClass: "mt-3 is-size-6 has-text-grey" }, [
              _c("span", { staticClass: "has-text-weight-semibold" }, [
                _vm._v("Note:"),
              ]),
              _vm._v(" This will replace the current primary image. "),
            ]),
          ]),
        ]
      ),
      _vm.isCarouselModalActive
        ? _c("bulma-carousel-modal", {
            attrs: {
              "image-width": 800,
              "image-height": 600,
              active: _vm.isCarouselModalActive,
              "image-ids": _vm.imageIds,
              "start-index": _vm.carouselStartIndex,
            },
            on: {
              "update:active": function ($event) {
                _vm.isCarouselModalActive = $event
              },
              close: _vm.closeCarousel,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-success" }, [
      _c("i", { staticClass: "mdi mdi-select-all mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-grey" }, [
      _c("i", { staticClass: "mdi mdi-select-off mdi-24px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }